export default "__VITE_ASSET__CUiifA_3__"